/* --------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */
import _ from 'lodash';
import service from '../../services/invites';

const INVITES_LOAD = 'INVITES_LOAD';
const INVITES_CREATE = 'INVITES_CREATE';
const INVITES_DELETE = 'INVITES_DELETE';

const state = {
  invites: null
};

const mutations = {
  [INVITES_LOAD] (state, invites) {
    state.invites = invites;
  },
  [INVITES_CREATE] (state, invite) {
    state.invites.push(invite);
  },
  [INVITES_DELETE] (state, deletedInvite) {
    if (deletedInvite) {
      let deletedIdx = _.findIndex(state.invites, i => {
        return i.inviteId === deletedInvite.inviteId;
      });
      if (deletedIdx > -1) {
        state.invites.splice(deletedIdx, 1);
      }
    }
  }
};

const actions = {
  getInvites: ({ commit }) => {
    return service.get()
      .then(invites => {
        commit(INVITES_LOAD, invites);
      });
  },
  createInvite: ({ commit }, data) => {
    return service.post(data)
      .then(invite => {
        commit(INVITES_CREATE, invite);
      });
  },
  editInvite: ({ }, data) => {
    // TODO: If we ever do allow modifying invites, we'll need to add INVITES_EDIT here
    return service.put(data.inviteId, data);
  },
  deleteInvite: ({ commit }, id) => {
    return service.delete(id)
      .then(deletedId => {
        commit(INVITES_DELETE, deletedId);
      });
  }
};

const getters = {
  invites: state => state.invites,
  invitesWithOrgLevelRole: state => {
    let invites = _.cloneDeep(state.invites);
    _.forEach(invites, invite => {
      // check if already has org-level roleValue
      let alreadyHasOrgLevelRole = (_.findIndex(invite.roles, (r) => r.groupId === null) >= 0);
      if (!alreadyHasOrgLevelRole) {
        invite.roles.unshift({ groupId: null, roles: [''] });
      }
    });
    return invites;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
